import { createSlideSet } from '@polleverywhere/slideware-bindings'
import { cloneDeep } from 'lodash'

async function createSlideSetFromStep (step, activity) {
  const queryInSlideNotes = _.extend({}, step.states.visualization, step.states.model)
  delete queryInSlideNotes.flash_options

  const activityQuery = { query: queryInSlideNotes }
  if (!_.isEmpty(queryInSlideNotes)) {
    activityQuery.persist = true
  }

  // Ensure the activity is hydrated so we can fetch the correct instance
  if (activity.get('shared_key') === activity.get('presenter_key')) {
    await activity.fetch()
  }

  const plholder = step.states.placeholder
  const placeholderActivityQuery = {
    activityQuery: {
      hide: plholder.hide.join(','),
      display_state: plholder.display_state,
      activity_state: plholder.activity_state
    }
  }

  return createSlideSet([activity], {
    urlOptions: {
      activityUrl: activityQuery,
      placeholderUrl: placeholderActivityQuery
    }
  })
}

async function convertDefault (activityFlow = {}, activity = {}) {
  return await Promise.all(activityFlow.steps.map((step) => {
    // Activity_state and display_state should not be set for the
    // default flow otherwise features like the timer and instructions
    // will not work because the state of viz is fixed.
    // Clone and removing these keys to allow these states for the default flow.
    // Be careful setting viz options for the default flow.
    if (activityFlow.name === 'Default') {
      const copyStep = cloneDeep(step)
      delete copyStep.states.visualization.activity_state
      delete copyStep.states.model.activity_state
      delete copyStep.states.visualization.display_state
      delete copyStep.states.model.display_state
      return createSlideSetFromStep(copyStep, activity)
    }
    return createSlideSetFromStep(step, activity)
  }))
}

async function convertSurvey (activityFlow = {}, activity = {}) {
  const slideSet = await createSlideSetFromStep(activityFlow.steps[0], activity)
  switch (activityFlow.name) {
    case 'Engagement':
      break
    case 'Default':
    default:
      // only take what we need, the first slide
      slideSet.slideData = slideSet.slideData.slice(0, 1)
  }

  return [slideSet]
}

export async function convertActivityFlowToSlideSet (activityFlow = {}, activity = {}) {
  if (activity.get('type') === 'survey') {
    return await convertSurvey(activityFlow, activity)
  }

  return await convertDefault(activityFlow, activity)
}
